<script setup lang="ts">
import { useOnTimezoneChange } from '@entities/viewer'
import { LoaderBlock } from '@shared/ui/loaders'
import { CardAdmin } from '@shared/ui/cards'

import { useDisciplineComments } from '../model/discipline-comments.hook'
import DisciplineCommentForm from './DisciplineCommentForm.vue'
import DisciplineCommentItem from './DisciplineCommentItem.vue'
import DisciplineKanbanLink from './DisciplineKanbanLink.vue'

defineOptions({
  name: 'DisciplineComments',
})

const {
  refListElement,
  refEditing,
  refKanbanUrl,
  comments,
  hasStage,
  isLoadingMore,
  fetchComments,
  setEditComment,
  setSavedComment,
} = useDisciplineComments()

onMounted(() => {
  void fetchComments()
})

// Row times arrive pre-shifted into the admin's view timezone.
useOnTimezoneChange(() => {
  void fetchComments()
})
</script>

<template>
  <CardAdmin
    title="Comments"
    class="discipline-comments"
    class-name="discipline-comments__body"
  >
    <template #header>
      <DisciplineKanbanLink
        v-if="refKanbanUrl"
        :href="refKanbanUrl"
      />
    </template>
    <template v-if="hasStage">
      <DisciplineCommentForm
        :key="refEditing?.id ?? 'new'"
        :comment="refEditing"
        @success:save="setSavedComment"
        @click:cancel="setEditComment(null)"
      />
      <div
        ref="refListElement"
        class="discipline-comments__list"
      >
        <DisciplineCommentItem
          v-for="comment in comments"
          :key="comment.id"
          :comment="comment"
          :selected="comment.id === refEditing?.id"
          editable
          @click:edit="setEditComment"
          @click:cancel="setEditComment(null)"
        />
        <div
          v-if="isLoadingMore"
          class="discipline-comments__loader"
        >
          <LoaderBlock size="sm" />
        </div>
      </div>
    </template>
  </CardAdmin>
</template>

<style scoped lang="scss" src="./DisciplineComments.scss" />
